/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
export const strings = {
    modifiedSubtitle: 'Modified',
    sizeSubtitle: 'Size'
};
//# sourceMappingURL=strings.js.map